import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

/*
 * Rappel housse de transport dans le panier : clic sur le bouton « Ajouter » (attribut data-fh-add).
 * Ajoute la housse au panier puis rafraîchit le tiroir et la page panier, comme le fait la fiche produit.
 */
if (!window.__feutreeHousseRappel) {
  window.__feutreeHousseRappel = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest && event.target.closest('[data-fh-add]');
    if (!button || button.disabled) return;

    button.disabled = true;
    button.classList.add('fh-cart__btn--busy');

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((component) => component.dataset.sectionId)
      .filter(Boolean);
    const variantId = button.dataset.variantId;
    const deferred = CartLinesUpdateEvent.createPromise();

    button.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionIds.join(','),
        }),
      });
      const result = await response.json();
      if (result.status) throw new Error(result.description || result.message || 'Ajout impossible');

      const cartResponse = await fetch(Theme.routes.cart_url + '.json', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      const cart = await cartResponse.json();

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          itemCount: cart.item_count,
          source: 'feutree-housse',
          sections: result.sections,
          didError: false,
        },
      });
    } catch (error) {
      deferred.reject(error);
      button.disabled = false;
      button.classList.remove('fh-cart__btn--busy');
      button.dispatchEvent(new CartErrorEvent({ error: error.message || 'Ajout impossible', code: 'INVALID' }));
    }
  });
}
